import { IServerMethods } from "../interfaces/utils.interface";

export class ServerMethods implements IServerMethods {
  ADD = "Add";
  GET = "Get";
  DELETE = "Delete";
  EDIT = "Edit";
  GET_SETTING = "GetSetting";
  REQUERY = "Requery";
}

export class ServerMethodsHelper implements IServerMethods {
  ADD = "";
  GET = "";
  DELETE = "";
  EDIT = "";
  GET_SETTING = "";
  REQUERY = "";

  get(method?: string): ServerMethodsHelper {
    this.GET = method || "";
    return this;
  }

  add(method?: string): ServerMethodsHelper {
    this.ADD = method || "";
    return this;
  }

  edit(method?: string): ServerMethodsHelper {
    this.EDIT = method || "";
    return this;
  }

  requery(method?: string): ServerMethodsHelper {
    this.REQUERY = method || "";
    return this;
  }

  delete(del?: string): ServerMethodsHelper {
    this.DELETE = del || "";
    return this;
  }

  getSetting(method?: string): ServerMethodsHelper {
    this.GET_SETTING = method || "";
    return this;
  }
}
